import { render } from "./Dossier.vue?vue&type=template&id=762ebad4"
import script from "./Dossier.vue?vue&type=script&lang=js"
export * from "./Dossier.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__